import React, { FC } from 'react'
import { Popconfirm as AntPopConfirm } from 'antd'
import { PopconfirmProps } from 'antd/lib/popconfirm'

export const PopConfirm: FC<PopconfirmProps> = ({ children, ...props }) => {
  return <AntPopConfirm {...props}>{children}</AntPopConfirm>
}
